<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<div class="dash-gis-report-tools" *ngIf="shouldDisplay$ | async"
     fxFlex="none" fxLayout="row" fxLayoutAlign="end center">
    <div fxLayout="row" fxLayoutAlign="end center">
        <dash-gis-upload *ngIf="definition.uploadFile"
                   [reportName]="definition.name"
                   [form]="definition.uploadFile"
                   [key]="objectKey"
                   [layer]="definition.layer"
                   [maxFiles]="1"
                   [allow]="definition.allowTypes ?? 'image/*'"
        ></dash-gis-upload>
        <dash-gis-zoom-button *ngIf="canZoom$ | async"
                        [zoomLayer]="definition.layer"
                        [zoomObjectKey]="objectKey"
                        [zoomObjectField]="definition.objectKey">
        </dash-gis-zoom-button>
        <button mat-icon-button *ngIf="canMovePoint$ | async"
                matTooltip="Move Point"
                (click)="movePoint()">
            <mat-icon svgIcon="pin-move" aria-label="Move Point"></mat-icon>
        </button>
        <button mat-icon-button
                *ngIf="canDeletePoint$ | async"
                matTooltip="Delete Point"
                (click)="deletePoint()">
            <mat-icon svgIcon="pin-off" aria-label="Delete Point"></mat-icon>
        </button>
        <ng-container *ngIf="mapEnabled$ | async">
            <dash-gis-line-isolation [mapName]="definition.map"
                               [layerName]="definition.layer"></dash-gis-line-isolation>
            <dash-gis-gspt [mapName]="definition.map"
                     [layerName]="definition.layer"></dash-gis-gspt>
        </ng-container>
        <button mat-icon-button
                *ngIf="canTableEdit$ | async"
                matTooltip="Edit Table Data"
                (click)="enableTableEdit()">
            <mat-icon svgIcon="table-edit" aria-label="Edit Table Data"></mat-icon>
        </button>
        <button mat-icon-button
               *ngIf="canEdit$ | async"
               matTooltip="Edit Data"
                   (click)="launchDataForm()">
            <mat-icon svgIcon="edit" aria-label="Edit Data"></mat-icon>
        </button>
        <dash-gis-report-print [definition]="definition"></dash-gis-report-print>
        <button mat-icon-button matTooltip="More"
                [matMenuTriggerFor]="moreMenu">
            <mat-icon svgIcon="more_vert" aria-label="More"></mat-icon>
        </button>
        <mat-menu #moreMenu="matMenu">
            <button mat-menu-item
                    [disabled]="!excelEnabled || !(hasData$ | async)"
                    (click)="downloadExcel()">
                <span>Download Excel</span>
                <mat-icon svgIcon="download" aria-label="Download Excel"></mat-icon>
            </button>
            <button mat-menu-item *ngFor="let otherReport of otherReports"
                    (click)="setOtherReport(otherReport)">
                <span>{{ otherReport.displayName }}</span>
            </button>
        </mat-menu>
    </div>
</div>
